module.exports = __webpack_public_path__ + "img/marketing_info_2.0bb0c1a8.jpg";